import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'
import FILTERED_TYPE from '@ublique/components/ColumnsFilterButtonTable/constant'

import {
  defaultColDef,
  findAndSetAppliedFilter,
  getColumnDefs,
  tableActionsConfig
} from '../config/table'
import { fetchDetailTable } from 'pages/Output/actions'
import { filter, isNull } from 'lodash'
import { useStoreSelector } from '@ublique/platform'

export const useStripeTablesConfig = () => {
  const { t } = useTranslation(['OutputView'])
  const { t: agGridT } = useTranslation('agGrid')

  const { scenarioId } = useParams()
  const [params, setParams] = useState()
  const [canSaveFilter, setCanSaveFilter] = useState(false)
  const [isActiveTabular, setIsActiveTabular] = useState(false)

  const [rowData, setRowData] = useState()

  const appliedNameFilter = useStoreSelector(
    'userPreferences',
    ({ output }) => {
      const filters = output?.filteredOutputColumns['detail_pivot']

      return filters?.find(({ selected }) => selected)?.name ?? undefined
    }
  )
  const userId = useStoreSelector('user', (user) => user.sub)

  useEffect(() => {
    async function fetchData() {
      const body = {
        start: 0,
        length: -1, // client side mode
        filter: {},
        sort: []
      }
      const response = await fetchDetailTable(scenarioId, body)

      setRowData(response?.body?.items ?? [])
    }
    fetchData()
  }, [scenarioId])

  const enableFilterBtn = {
    setIsActiveTabular,
    tabular: isActiveTabular,
    canSaveFilter,
    gridApi: params?.api,
    identifier: 'pivot',
    kind: 'output',
    type: FILTERED_TYPE.PIVOT,
    id: 'detail_pivot',
    userId,
    t: agGridT
  }

  const extraHeaderComponent = {
    extraHeaderComponentContainerClassName: 'extraComponent',
    extraHeaderComponent: {
      t,
      //selectedRowsCount: selectionParams.count,
      //selectedRowsLabel: t(SELECTED_ROWS_COUNT, {
      //rowsCount: selectionParams.count
      //}),
      config: tableActionsConfig({
        btnFilterT: agGridT,
        t,
        gridApi: params?.api,
        isActiveTabular,
        setIsActiveTabular,
        enableFilterBtn,
        filterName: appliedNameFilter
      })
    }
  }
  const getColumnsWithState = () => {
    const columnsState = params.api.gridCore.columnApi.getColumnState()

    const enableColumns = filter(
      columnsState,
      ({ aggFunc, pivotIndex, rowGroupIndex }) =>
        !isNull(aggFunc) || !isNull(pivotIndex) || !isNull(rowGroupIndex)
    )

    return enableColumns
  }

  return {
    stripeTables: [
      {
        config: { sm: 4, md: 8, lg: 12 },
        tableProps: {
          onRowDataChanged: (params) => {
            findAndSetAppliedFilter(params)
          },
          onColumnPivotChanged: () => {
            const enableColumns = getColumnsWithState()
            setCanSaveFilter(isEmpty(enableColumns) ? false : true)
          },
          onColumnRowGroupChanged: () => {
            const enableColumns = getColumnsWithState()
            setCanSaveFilter(isEmpty(enableColumns) ? false : true)
          },
          onColumnValueChanged: () => {
            const enableColumns = getColumnsWithState()
            setCanSaveFilter(isEmpty(enableColumns) ? false : true)
          },
          onGridReady: setParams,
          defaultColDef,
          columnDefs: getColumnDefs(t, true),
          filter: false,
          canSearch: false,
          rowData,
          minHeight: '70vh',
          pivotMode: false,
          pivotRowTotals: 'after',
          groupIncludeFooter: true,
          groupIncludeTotalFooter: true,
          enablePivot: {
            allFeature: true,
            groupIncludeFooter: true
          },
          autoGroupColumnDef: {
            minWidth: 180,
            cellRendererParams: {
              suppressCount: true
            }
          },
          ...extraHeaderComponent
        }
      }
    ]
  }
}
